import * as React from 'react';
function onDragOver(ev) {
    ev.preventDefault();
}
export var UploadField = function (_a) {
    var emptyLabel = _a.emptyLabel, fullLabel = _a.fullLabel, disabled = _a.disabled, multiple = _a.multiple, onChange = _a.onChange, error = _a.error, children = _a.children;
    var cls = "upload-field".concat(error ? ' error' : '');
    var _b = React.useState(false), over = _b[0], setOver = _b[1];
    var _c = React.useState([]), files = _c[0], setFiles = _c[1];
    var inputRef = React.useRef();
    var openFilePicker = React.useCallback(function () {
        if (inputRef.current) {
            inputRef.current.click();
        }
    }, []);
    var changeFiles = React.useCallback(function (fileList) {
        var files = [];
        if (!disabled) {
            if (multiple) {
                files.push.apply(files, fileList);
            }
            else {
                files.push(fileList[0]);
            }
            setFiles(files);
            if (typeof onChange === 'function') {
                onChange(files);
            }
        }
    }, [onChange, multiple, disabled]);
    var onDragEnter = React.useCallback(function () { return setOver(function () { return true; }); }, []);
    var onDragLeave = React.useCallback(function () { return setOver(function () { return false; }); }, []);
    var onDrop = React.useCallback(function (ev) {
        ev.preventDefault();
        onDragLeave();
        changeFiles(ev.dataTransfer.files);
    }, [changeFiles]);
    var change = React.useCallback(function (ev) {
        changeFiles(ev.target.files);
    }, [changeFiles]);
    return (React.createElement("div", { className: "form-group" },
        React.createElement("div", { className: cls, "data-over": over, "data-files": files.length, onDrop: onDrop, onDragOver: onDragOver, onDragLeave: onDragLeave, onDragEnter: onDragEnter, onClick: openFilePicker },
            React.createElement("label", null, files.length === 0 ? emptyLabel : fullLabel),
            React.createElement("input", { type: "file", ref: inputRef, onChange: change, multiple: multiple }),
            children)));
};
//# sourceMappingURL=index.js.map